module.exports = __webpack_public_path__ + "img/add-icon.f0e6cbde.svg";